<template>
  <div class="pa-3 elevation-2 information">
    <p class="mb-0">{{ item }}</p>
    <slot></slot>
    <div class="information-border" :class="color"></div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: String
    },
    color: {
      type: String,
      default: "green"
    }
  }
};
</script>

<style>
.information {
  border-radius: 8px;
  margin-bottom: 16px;
  position: relative;
  display: block;
}
.information-border {
  border-style: solid;
  border-width: 3px;
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  border-top-left-radius: inherit;
  border-bottom-left-radius: inherit;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/base/Information.vue